import * as React from 'react'
import { withRouter } from 'react-router-dom'

export class ScrollToTop extends React.Component<any> {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) window.scrollTo(0, 0)
  }

  render() {
    const { children } = this.props
    return children
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/containers/ScrollToTop.tsx